<div class="fa-7x spinner-container">
    <!-- <i class="fas fa-spinner fa-spin"></i> -->
    <!-- <i class="fas fa-circle-notch fa-spin"></i> -->
    <!-- <i class="fas fa-sync fa-spin"></i> -->
    <i class="fas fa-cog fa-spin"></i>
    <!-- <i class="fas fa-spinner fa-pulse"></i> -->
    <!-- <i class="fas fa-stroopwafel fa-spin"></i> -->
</div>